package org.matthewo.pages

import io.ktor.client.call.*
import io.ktor.client.plugins.resources.*
import js.coroutines.awaitCancellation
import kotlinx.coroutines.launch
import org.matthewo.YEAR_PARAM
import org.matthewo.api.EventCompetitionSimple
import org.matthewo.client
import org.matthewo.hooks.useCoroutineScope
import org.matthewo.pages.team.tabs.toTeam
import org.matthewo.plots.MetricComparisonScatterPlot
import org.matthewo.routes.API
import org.matthewo.schema.ALL_YEARS
import org.matthewo.useDefaultHeader
import org.matthewo.useLoading
import react.FC
import react.useEffect
import react.useState
import tanstack.react.router.useNavigate
import tanstack.react.router.useParams

val GameTeamsPeriodsScatterPlot = FC("GameTeamsPeriodsScatterPlot") {
    useDefaultHeader(ALL_YEARS)

    val coroutineScope = useCoroutineScope()
    val pathParams = useParams()

    val year = pathParams[YEAR_PARAM]

    val navigate = useNavigate()

    var teams by useState<List<EventCompetitionSimple>>()

    useLoading(null == teams)

    useEffect(pathParams) {
        val year = year?.toIntOrNull() ?: return@useEffect
        val job = coroutineScope.launch {
            teams = client.get(API.Year(year)).body()
        }
        awaitCancellation {
            job.cancel()
            teams = null
        }
    }

    MetricComparisonScatterPlot {
        data = teams ?: []
        sumMetricTitle = "NP Total"
        xMetricTitle = "Teleop"
        xMetric = { competition: EventCompetitionSimple -> competition.teleopOpr }
        yMetricTitle = "Auto + Endgame"
        yMetric = { competition: EventCompetitionSimple -> competition.autoOpr + competition.endgameOpr }
        pointLabel = { competition: EventCompetitionSimple -> "${competition.number}" }
        tooltipLabel = { competition: EventCompetitionSimple -> "${competition.number} - ${competition.name}" }
        lookup = { competition: EventCompetitionSimple -> competition.number }
        onClick = { competition: EventCompetitionSimple ->
            navigate {
                toTeam(teamNumber = competition.number)
            }
        }
        onlyShowTopLabels = true
    }
}
